import { Optional, Inject, Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { Filter } from '../../shared/filter';
import { BaseService } from '../base.service';
import { BaseApiServiceInterface } from './base.service.interface';
import { BaseErrorService } from '../error/base.service';
import { BaseLoopBackStorageService } from '../storage/loopback/base.service';
import { environment } from '../../../environments/environment';
import { HTTP_METHOD } from "../../shared/constants";

@Injectable()
export abstract class BaseApiService extends BaseService implements BaseApiServiceInterface {
  baseUrl: string = '';
  modelName: string = '';
  pathUrl: string = '';
  headers: {};

  constructor(
    protected httpClient: HttpClient,
    protected storageService: BaseLoopBackStorageService,
    protected errorService: BaseErrorService
  ) {
    super();
    this.baseUrl = environment.baseUrl + environment.basePath;
  }

  /**
   * @param method
   * @param options
   */
  request(method: string, options: any) {
    let self = this;
    // Replace headers
    self.headers = {};
    if (options.headers) {
      var headerNames = Object.keys(options.headers);
      headerNames.forEach(function(headerName) {
        self.headers[headerName] = options.headers[headerName];
      });
    }
    // Set default content-type
    if (typeof(self.headers['Content-Type']) === 'undefined') {
      self.headers['Content-Type'] = 'application/json';
    }

    // Some special case like upload we don't need to provide content-type in headers
    if (self.headers['Content-Type'] === null) {
      delete self.headers['Content-Type'];
    }

    // Set accessToken to header
    if (self.storageService.getAccessToken()) {
      self.headers['Authorization'] = self.storageService.getAccessToken();
    }

    // Add modelName to URL (Staffs, ...)
    let requestUrl = options.url ? options.url : self.baseUrl;

    if (options.modelName) {
      requestUrl = requestUrl + '/' + options.modelName;
    } else {
      requestUrl = requestUrl + '/' + self.modelName;
    }

    // Add Path to URL (login, logout, ...)
    if (options.pathUrl) {
      requestUrl = requestUrl + '/' + options.pathUrl;
    } else {
      requestUrl = requestUrl + '/' + self.pathUrl;
    }

    let urlParams = options.urlParams || [];
    let key: string;
    for (key in urlParams) {
      requestUrl = requestUrl.replace(new RegExp(":" + key + "(\/|$)", "g"), urlParams[key] + "$1");
    }
    let params = options.params || [];
    let parameters: string[] = [];
    for (var param in params) {
      parameters.push(param + '=' + (typeof params[param] === 'object' ? JSON.stringify(params[param]) : params[param]));
    }
    requestUrl += (parameters ? '?' : '') + parameters.join('&');

    delete options.urlParams;
    delete options.params;
    // Because HttpHeaders can not set or append new header so we must do like this.
    options.headers = new HttpHeaders(self.headers);
    return self.httpClient.request(method, requestUrl, options)
      .catch( function (response: any) {
        return self.errorService.handleError(response);
      });
  }

  /**
   *
   * @param options
   */
  get(options: any) {
    return this.request(HTTP_METHOD.GET, options);
  }

  /**
   *
   * @param options
   */
  post(options: any) {
    return this.request(HTTP_METHOD.POST, options);
  }

  /**
   *
   * @param options
   */
  patch(options: any) {
    return this.request(HTTP_METHOD.PATCH, options);
  }

  /**
   *
   * @param options
   */
  put(options: any) {
    return this.request(HTTP_METHOD.PUT, options);
  }

  /**
   *
   * @param options
   */
  delete(options: any) {
    return this.request(HTTP_METHOD.DELETE, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/api/base.service.ts